var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video"},[(_vm.src)?_c('video',{ref:"video",attrs:{"no-controls":"","autoplay":"","muted":"","playsinline":"","poster":require(`@/${_vm.poster}`)},domProps:{"muted":true}},[_c('source',{attrs:{"src":require(`@/${_vm.src}`),"type":`video/${_vm.type}`}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }